export enum AppEventType {
  UserLoggedOn,
  UserLoggedOff,
  TwitterDisputeResolutionAdded
}
